import { Injectable } from '@angular/core';
import { ApiV1_Category, ApiV1_Product } from '@pedix-workspace/api-v1';
import { getAllSearchEntries, searchInIndex } from '../utils/search-index';
import { combineLatest, map, Observable } from 'rxjs';
import {
  createSearchCatalogIndex,
  SearchCatalogIndex,
  SearchCatalogIndexOptions,
} from '../utils/search-catalog-index';

@Injectable({ providedIn: 'root' })
export abstract class SearchResultsService {
  private searchIndex: SearchCatalogIndex | null;

  abstract getCategories(): Observable<ApiV1_Category[]>;
  abstract getProducts(): Observable<ApiV1_Product[]>;

  invalidateIndex() {
    this.searchIndex = null;
  }

  getSearchResults(
    searchTerm: string,
    options: SearchCatalogIndexOptions,
  ): Observable<ApiV1_Product[]> {
    return combineLatest([this.getCategories(), this.getProducts()]).pipe(
      map(([categories = [], products = []]) => {
        if (!this.searchIndex) {
          this.searchIndex = createSearchCatalogIndex(categories, products, options);
        }
        if (!searchTerm) {
          return getAllSearchEntries(this.searchIndex);
        }

        return searchInIndex(this.searchIndex, searchTerm);
      }),
    );
  }

  getFilteredResults(products: ApiV1_Product[], filters: { productTagIds?: string[] } = {}) {
    if (!filters.productTagIds || filters.productTagIds.length === 0) {
      return products;
    }
    return products.filter(product => {
      if (product.linkedProductTagIds) {
        return product.linkedProductTagIds.some(tagId => filters.productTagIds?.includes(tagId));
      } else {
        return true;
      }
    });
  }
}
